module.exports = __webpack_public_path__ + "static/media/IMG-11.f150fc52.jpg";